import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors, fonts } from './designSystem';

// ---------------------------------------------------------------------------
// Animations
// ---------------------------------------------------------------------------

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

// ---------------------------------------------------------------------------
// Styled Components
// ---------------------------------------------------------------------------

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px 120px;
  gap: 28px;
`;

const WheelContainer = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  animation: ${spin} 1s linear infinite;
`;

const Rim = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 4px solid ${colors.bleuPastel};
  border-top-color: ${colors.bleu};
  border-right-color: ${colors.bleu};
  box-sizing: border-box;
`;

const Spoke = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 1.5px;
  background: ${colors.bleuClair};
  transform-origin: center;
  transform: translate(-50%, -50%) rotate(${(props) => props.angle}deg);
`;

const Hub = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${colors.vert};
  border: 2px solid ${colors.bleuFonce};
  transform: translate(-50%, -50%);
`;

const Text = styled.p`
  font-family: ${fonts.body};
  font-size: 1rem;
  color: ${colors.bleuFonce};
  margin: 0;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const DotsRow = styled.div`
  display: flex;
  gap: 8px;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.color};
  animation: ${bounce} 0.6s ease-in-out infinite;
  animation-delay: ${(props) => props.delay}s;
`;

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

const BikeWheelLoader = ({ label = 'Chargement des ateliers...' }) => (
  <Wrapper>
    <WheelContainer>
      <Rim />
      <Spoke angle={0} />
      <Spoke angle={45} />
      <Spoke angle={90} />
      <Spoke angle={135} />
      <Hub />
    </WheelContainer>
    <Text>{label}</Text>
    <DotsRow>
      <Dot color={colors.vert} delay={0} />
      <Dot color={colors.bleu} delay={0.15} />
      <Dot color={colors.orange} delay={0.3} />
    </DotsRow>
  </Wrapper>
);

export default BikeWheelLoader;
